import { apiClient } from '@/lib/apiClient';

/**
 * Multi-role discovery + active-role switching for the UserMenu role
 * switcher (epic 115). Pairs with the backend RoleSwitchController.
 *
 * The backend treats the active role as a client-side preference: it
 * validates that the requested role is one the user holds and returns
 * 200, but does NOT reissue a JWT. Permissions are the union of all
 * granted role permissions anyway, so the active role only changes UI
 * concerns (dashboard redirect target, role-scoped tour). See backend
 * RoleSwitchController kdoc.
 */
export interface MyRolesResponse {
  primaryRole: string;
  roles: string[];
}

export interface SwitchRoleResponse {
  role: string;
  switchedAt: string;
}

export async function fetchMyRoles(): Promise<MyRolesResponse> {
  const { data } = await apiClient.get<MyRolesResponse>('/auth/my-roles');
  return data;
}

export async function switchRole(role: string): Promise<SwitchRoleResponse> {
  const { data } = await apiClient.post<SwitchRoleResponse>('/auth/switch-role', { role });
  return data;
}
